import { useCallback, useEffect, useRef, useState } from 'react';

/**
 *
 * @param timout in ms
 * @param initial
 * @returns [0] current value, [1] debounced value /settled value after timout, [2] set method
 */
const useDebounce = <T>(_timout: number, initial: T): [T, T, (value: T) => void] => {
  const timeout = useRef<NodeJS.Timeout | undefined>(undefined);

  const [currentValue, setCurrentValue] = useState(initial);
  const [debouncedValue, setDebouncedValue] = useState(initial);

  const _setCurrentValue = useCallback((value: T) => setCurrentValue(value), []);

  useEffect(() => {
    if (timeout.current) {
      clearTimeout(timeout.current as unknown as number);
    }

    timeout.current = setTimeout(() => {
      setDebouncedValue(currentValue);
    }, 500);
  }, [currentValue]);

  return [currentValue, debouncedValue, _setCurrentValue];
};

export default useDebounce;
